import type { BadgeTone } from '@psspl/ui';

import type { Role } from '../types';

/**
 * Display vocabulary for the roles in `@psspl/types` (`docs/api.md` §4.2).
 *
 * Labels and colours only. What a role may do is decided by the API
 * (`docs/security.md` section 4); nothing here grants or hides data.
 */
export const ROLE_LABEL: Record<Role, string> = {
  SUPER_ADMIN: 'Super Administrator',
  ADMIN: 'Administrator',
  BD_MEMBER: 'Business Development',
  CLIENT: 'Client',
};

/**
 * Administrative roles take the warm accent (Super Administrator the gold, Admin
 * the amber); BD and Client take the cool blues. The label is always spelled out,
 * so colour is never the only signal.
 */
export const ROLE_TONE: Record<Role, BadgeTone> = {
  SUPER_ADMIN: 'accent',
  ADMIN: 'warning',
  BD_MEMBER: 'info',
  CLIENT: 'brand',
};
